var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.27773 5.47941C7.1736 5.47941 8.7153 7.02083 8.7153 8.9167C8.7153 10.8126 7.17356 12.3546 5.27773 12.3546C3.38186 12.3546 1.83983 10.8125 1.83983 8.9167C1.83983 7.02083 3.38158 5.47941 5.27773 5.47941ZM16.57 14.4015C16.3295 17.337 14.3377 18.0747 11.6905 17.5347C13.6146 17.276 14.9124 16.2141 15.1496 14.4015H13.6797L15.8915 11.0108L18.1036 14.4015H16.57ZM16.021 0C17.9168 0 19.4585 1.54174 19.4585 3.43758C19.4585 5.33313 17.9168 6.87515 16.021 6.87515C14.1251 6.87515 12.5834 5.33309 12.5834 3.43758C12.5834 1.5417 14.1248 0 16.021 0ZM16.021 7.1775C19.4376 7.1775 21.2964 9.83733 21.2964 13.032H17.7122L16.957 11.8746H20.0987C19.813 9.84727 18.0722 8.33498 16.0208 8.33498C13.9694 8.33498 12.2291 9.84698 11.9434 11.8746H14.8265L14.0712 13.032H10.7453C10.7453 9.83693 12.6044 7.1775 16.0211 7.1775H16.021ZM5.27777 12.6565C8.69438 12.6565 10.5532 15.316 10.5532 18.511H0.00195312C0.00195312 15.3158 1.86103 12.6565 5.27777 12.6565ZM5.27777 13.8141C3.22628 13.8141 1.48575 15.3261 1.20027 17.3537H9.35566C9.06995 15.3264 7.3291 13.8141 5.27777 13.8141ZM5.27777 6.63657C4.01596 6.63657 2.99771 7.65494 2.99771 8.9163C2.99771 10.1781 4.01592 11.1964 5.27777 11.1964C6.53929 11.1964 7.5575 10.1781 7.5575 8.9163C7.5575 7.6551 6.53929 6.63657 5.27777 6.63657Z",
    fill: "#109615"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.6ee0d43f03d84ce1a38ab481f1c13478.svg";
export { ForwardRef as ReactComponent };